module.exports = __webpack_public_path__ + "static/Mask-Group-15-fbe53b3e6eedd236414554f36a1d1dbd.svg";